import { render } from "./role.vue?vue&type=template&id=ce995294&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"

import "./role.vue?vue&type=style&index=0&id=ce995294&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ce995294"

export default script